import { environment } from 'app/core/environments/environment';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class UserPermissionsService {
	apiUrl = `${environment.financialUrl}/aps`;

	userId: string;

	constructor(private http: HttpClient) {
		this.userId =
			sessionStorage.getItem('username') ||
			sessionStorage.getItem('userId') ||
			'';
	}

	getPermissions() {
		if (!this.userId) {
			this.userId =
				sessionStorage.getItem('username') ||
				sessionStorage.getItem('userId') ||
				'';
		}
		return this.http.get<any[]>(`${this.apiUrl}/${this.userId}`);
	}
}
